import { useMutation } from '@tanstack/react-query';
import { isArray } from 'lodash';
import { useNavigate } from 'react-router-dom';

import { useLoader } from 'Store/loader';
import { useToast } from 'Store/toast';
import { confirmCreateText } from 'Const/schedule-ruleset/view';
import postShopeeCallback from 'Api/shopee/postShopeeCallback';

import postShopeeCallbackPayload from './model/request/postShopeeCallbackPayload';

const usePostShopeeCallback = () => {
  const { onShowLoader, onResetLoader } = useLoader();
  const { onOpenToast, onResetToast } = useToast();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (params) => {
      const payload = postShopeeCallbackPayload(params);

      const result = await postShopeeCallback(payload);

      return result;
    },
    onMutate: () => onShowLoader({ variant: 'loader-primary' }),
    onSettled: () => onResetLoader(),
    onSuccess: () => {
      onResetToast();

      onOpenToast({
        status: 'success',
        description: 'Berhasil sync',
        duration: 5,
        alwaysShow: false,
      });

      navigate('/master-data/account-livestream');
    },
    onError: (error) => {
      const errorMessage = isArray(error?.response?.data?.errors) ? error?.response?.data?.errors[0]?.message : confirmCreateText?.errorDescription;
      onResetToast();

      onOpenToast({
        status: 'error',
        title: 'Error',
        description: errorMessage,
        duration: 5,
        alwaysShow: false,
      });
    },
  });
};

export default usePostShopeeCallback;
